module.exports = __webpack_public_path__ + "static/media/DayView.868d9512.svg";